import Vue from 'vue';
import App from './App.vue';
import router from './core/router';
import {vuexStore} from './core/store';
import FontAwesomeBuilder from "./core/fontawesome";

Vue.config.productionTip = false;

Vue.filter('score', (s: string | number) => `${(Number(s) * 100).toFixed(1)}%`);
Vue.filter('language', (s: string) => {
  switch (s) {
    case 'en':
      return 'English';
    case 'fr':
      return 'French';
    default:
      return s;
  }
});

const fontawesome = require("@fortawesome/vue-fontawesome");
Vue.component('font-awesome-icon', fontawesome.FontAwesomeIcon);
FontAwesomeBuilder.buildLibrary();

new Vue({
  router,
  store: vuexStore,
  render: (h) => h(App),
}).$mount('#app');
